import type { CatalogItem } from '@viva/core';

/**
 * Channel qualities (#100): the relay lists each channel once and carries its
 * other qualities in `data.variants`; the player switches between them, and the
 * last choice is kept for the next channels (like YouTube).
 */

const PREFERENCE_KEY = 'viva.player.quality';

export function readQualityPreference(): string | null {
  try {
    return localStorage.getItem(PREFERENCE_KEY);
  } catch {
    return null;
  }
}

export function saveQualityPreference(quality: string): void {
  try {
    localStorage.setItem(PREFERENCE_KEY, quality);
  } catch {
    // Not remembering only costs a tap next time.
  }
}

/** The item to play: the channel in the chosen quality when it has one, else as listed (HD by default). */
export function withQuality(item: CatalogItem, quality: string | null): CatalogItem {
  const variant = quality === null ? undefined : item.data.variants?.find((entry) => entry.quality === quality);
  return variant && variant.url !== item.url ? { ...item, url: variant.url } : item;
}

/** What the menu shows for one quality: "Standard" when the provider's name gives none ("2" is its second copy). */
export function qualityName(quality: string, fallback: string): string {
  if (!quality) return fallback;
  return /^\d+$/.test(quality) ? `${fallback} ${quality}` : quality;
}
